import React from 'react';
import { useTranslation } from 'react-i18next';

import { AccountKeyData } from './account-models';
import { deletePubicKey } from './account-store';
import { GenericDeleteModal } from 'src/js/component/generic-delete-modal';

interface Props {
  name: string;
  itemsToDelete: AccountKeyData[];
  onSuccess: (items: AccountKeyData[]) => void;
  onCancel?: VoidFunction;
}

export const DeleteAccountPubkeyModal: React.FunctionComponent<Props> = ({
  name,
  itemsToDelete,
  onSuccess,
  onCancel,
}) => {
  const { t } = useTranslation();

  const handleDelete = () => {
    return Promise.all(itemsToDelete.map((e) => deletePubicKey(name, e.name, t))).then((responses) => {
      const failed = responses.filter((r) => !r.ok);
      if (failed.length === 0) {
        onSuccess?.(itemsToDelete);
      }
      return responses;
    });
  };

  return (
    <GenericDeleteModal
      title={t('security.accounts.pubkeys.delete.title', { count: itemsToDelete.length })}
      itemsToDelete={itemsToDelete}
      onDelete={handleDelete}
      onCancel={onCancel}
    />
  );
};
